import { render } from "./footerSuperAdmin.vue?vue&type=template&id=111e08b3&scoped=true"
import script from "./footerSuperAdmin.vue?vue&type=script&lang=js"
export * from "./footerSuperAdmin.vue?vue&type=script&lang=js"

import "./footerSuperAdmin.vue?vue&type=style&index=0&id=111e08b3&lang=css"
import "./footerSuperAdmin.vue?vue&type=style&index=1&id=111e08b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111e08b3"]])

export default __exports__